import { ServiceStackTypeCategories, ServiceStackTypes } from '@zerops/models/service-stack';

export const FEATURE_NAME = '@zerops/zerops/core/service-stack-base';

export enum ServiceStackOperationTypes {
  Stop = 'stop',
  Start = 'start',
  Restart = 'restart',
  Reload = 'reload'
}

export enum PipelineDebugPhases {
  DEBUG_BUILD = 'debugBuild',
  DEBUG_RUNTIME_PREPARE = 'debugRuntimePrepare'
}

export enum PipelineDebugPhasesUserDataKeys {
  DEBUG_BUILD = 'ZEROPS_DEBUG_BUILD',
  DEBUG_RUNTIME_PREPARE = 'ZEROPS_DEBUG_RUNTIME_PREPARE'
}

export enum PipelineDebugModes {
  NONE = 'NONE',
  BEFORE = 'BEFORE',
  ON_FAIL = 'ON_FAIL',
  AFTER = 'AFTER'
}

// TODO: `postgres` temp
export const FORBIDDEN_STACK_IDS = [ 'contabo_ssh', 'build', 'runtime', 'zcp' ];

export const FORBIDDEN_STACK_CATEGORIES = [ 'BUILD', 'PREPARE_RUNTIME' ];

export const BUILD_STACK_CATEGORY = 'BUILD';

export const NOT_IMPORTANT_STACK_IDS = [
  ServiceStackTypes.Seaweedfs,
  ServiceStackTypes.ObjectStorage,
  ServiceStackTypes.LocalStorage,
  ServiceStackTypes.PhpApache,
  ServiceStackTypes.Zcp
];

/**
 * Non-user (STANDARD) service types that still expose public HTTP / port routing,
 * user service types (runtimes, docker, swarm_vm, ...) have it regardless.
 */
export const PUBLIC_ROUTING_SERVICE_STACK_TYPES = new Set<string>([
  ServiceStackTypes.RabbitMq,
  ServiceStackTypes.Meilisearch,
  ServiceStackTypes.Typesense,
  ServiceStackTypes.Clickhouse,
  ServiceStackTypes.Elasticsearch,
  ServiceStackTypes.ZBox
]);

export enum ServiceStackTextCategories {
  Database = 'database',
  Messaging = 'messaging',
  PhpWebserver = 'phpWebserver',
  Webserver = 'webserver',
  Static = 'static',
  RuntimeEnvironment = 'runtimeEnvironment',
  ProgrammingLanguage = 'programmingLanguage',
  SearchEngine = 'searchEngine',
  Storage = 'storage',
  ObjectStorage = 'objectstorage',
  LinuxContainer = 'linuxContainer',
  VirtualMachine = 'virtualMachine',
  Zcp = 'zcp'
}

export enum ServiceStackCategories {
  Managed = 'managed',
  Runtime = 'runtime',
  Storage = 'storage',
  Bare = 'bare',
  Static = 'static'
}

export const SERVICE_STACK_PRIORITY_MAP = {
  // runtimes
  [ServiceStackTypes.Static]: 0,
  [ServiceStackTypes.Nginx]: 1,
  [ServiceStackTypes.Ubuntu]: 2,
  [ServiceStackTypes.Alpine]: 3,
  [ServiceStackTypes.Docker]: 4,
  [ServiceStackTypes.NodeJs]: 5,
  [ServiceStackTypes.Bun]: 6,
  [ServiceStackTypes.Deno]: 7,
  [ServiceStackTypes.Golang]: 8,
  [ServiceStackTypes.Rust]: 9,
  [ServiceStackTypes.Python]: 10,
  [ServiceStackTypes.DotNet]: 11,
  [ServiceStackTypes.Java]: 12,
  [ServiceStackTypes.PhpApache]: 13,
  [ServiceStackTypes.PhpNginx]: 14,
  [ServiceStackTypes.Elixir]: 15,
  [ServiceStackTypes.Gleam]: 16,
  [ServiceStackTypes.Ruby]: 17,

  // relational
  [ServiceStackTypes.MariaDb]: 100,
  [ServiceStackTypes.Postgres]: 101,
  [ServiceStackTypes.Clickhouse]: 102,

  // document
  [ServiceStackTypes.Redis]: 200,
  [ServiceStackTypes.Valkey]: 201,
  [ServiceStackTypes.MongoDb]: 202,

  // vector
  [ServiceStackTypes.Qdrant]: 300,

  // search engines
  [ServiceStackTypes.Elasticsearch]: 400,
  [ServiceStackTypes.Meilisearch]: 401,
  [ServiceStackTypes.Typesense]: 402,

  // messaging
  [ServiceStackTypes.RabbitMq]: 500,
  [ServiceStackTypes.Nats]: 501,
  [ServiceStackTypes.Kafka]: 502,

  // virtual machines, after docker in the containers and VMs group
  [ServiceStackTypes.SwarmVm]: 540,
  [ServiceStackTypes.ZBox]: 550,

  // storages
  [ServiceStackTypes.ObjectStorage]: 600,
  [ServiceStackTypes.LocalStorage]: 601,
  [ServiceStackTypes.Seaweedfs]: 602,

  // zcp
  [ServiceStackTypes.Zcp]: 700,
};

export const SERVICE_STACK_NEXT_NAME_TEXT_MAP = {
  [ServiceStackTypes.Redis]: 'keydb'
};

export const PROJECT_BACKUPS_PAGE_SIZE = 20;

// Which service detail runtime pages a type category has; shared by the detail menu,
// the command palette and the page guards so they can't drift apart.
export const hasDeployPage = (typeCategory?: string) => typeCategory === ServiceStackTypeCategories.User;

export const hasShellAccess = (typeCategory?: string) => typeCategory === ServiceStackTypeCategories.User
  || typeCategory === ServiceStackTypeCategories.LocalStorage;
